module.exports = __webpack_public_path__ + "img/students@3x.33263bed.png";